export enum InternalActionTypes {
  RequestLoadingError = 'RequestLoadingError',
  RequestSuccessful = 'RequestSuccessful',
  ClearRequestErrors = 'ClearRequestErrors',
  AllUsersLoaded = 'AllUsersLoaded',
  UserCreated = 'UserCreated',
  UserEdited = 'UserEdited',
  UserLoaded = 'UserLoaded',
  PasswordChanged = 'PasswordChanged',
  LoginSuccessful = 'LoginSuccessful',
  ActiveClientsLoaded = 'ActiveClientsLoaded',
  ClientCreated = 'ClientCreated',
  ClientEdited = 'ClientEdited',
  SummaryDownloaded = 'SummaryDownloaded',
  ClientArchived = 'ClientArchived',
  ClientUnarchived = 'ClientUnarchived',
  EventLoaded = 'EventLoaded',
  EventCreated = 'EventCreated',
  EventEdited = 'EventEdited',
  EventArchived = 'EventArchived',
  EventUnarchived = 'EventUnarchived',
  AllShopsLoaded = 'AllShopsLoaded',
  ShopCreated = 'ShopCreated',
  EventParticipantLoaded = 'EventParticipantLoaded',
  LiveAndHybridEventParticipantsLoadedAction = 'createLiveAndHybridEventParticipantsLoadedAction',
  EventParticipantAdded = 'EventParticipantAdded',
  EventParticipantEdited = 'EventParticipantEdited',
  MergedParticipants = 'MergedParticipants',
  ConvertedToUnknownParticipant = 'ConvertedToUnknownParticipant',
  EventParticipantsUploaded = 'EventParticipantsUploaded',
  EventAssigned = 'EventAssigned',
  Logout = 'Logout',
  EventTransitionLoaded = 'EventTransitionLoaded',
  EventVideosLoaded = 'EventVideosLoaded',
  EventArchivedVideosLoaded = 'EventArchivedVideosLoaded',
  DefaultClipConfigurationLoaded = 'DefaultClipConfigurationLoaded',
  EventVideoLoaded = 'EventVideoLoaded',
  UploadedVideosLoaded = 'UploadedVideosLoaded',
  CloseModal = 'CloseModal',
  UpdateFormData = 'UpdateFormData',
  EventActionsLoaded = 'EventActionsLoaded',
  EventArchivedActionsLoaded = 'EventArchivedActionsLoaded',
  OpenModal = 'OpenModal',
  EventStatisticsLoaded = 'EventStatisticsLoaded',
  ActiveEventsLoaded = 'ActiveEventsLoaded',
  ArchivedEventsLoaded = 'ArchivedEventsLoaded',
  ArchivedClientsLoaded = 'ArchivedClientsLoaded',
  EventParticipantsLoaded = 'EventParticipantsLoaded',
  EventArchivedParticipantsLoaded = 'EventArchivedParticipantsLoaded',
  ParticipantReviewStatusUpdated = 'ParticipantReviewStatusUpdated',
  ParticipantVirtualGraduationAccepted = 'ParticipantVirtualGraduationAccepted',
  ParticipantVirtualGraduationRejected = 'ParticipantVirtualGraduationRejected',
  EventParticipantDeleted = 'EventParticipantDeleted',
  ClearSyncErrors = '@@redux-form/UPDATE_SYNC_ERRORS',
  RemoveVgQaParticipant = 'RemoveVgQaParticipant',
  ResetParticipantsList = 'ResetParticipantsList',
  ParticipantBlacklistAdded = 'ParticipantBlacklistAdded',
  ParticipantBlacklistRemoved = 'ParticipantBlacklistRemoved',
  VideoReminderEmailSent = 'VideoReminderEmailSent',
  UserDeleted = 'UserDeleted',
  EventCancelled = 'EventCancelled',
  EmailPrevievSent = 'EmailPrevievSent',
  EventSentToNLP = 'EventSentToNLP',
  UnlockTemplate = 'UnlockTemplate',
  UnlockClip = 'UnlockClip',
  ResetRender = 'ResetRender',
}

export enum DataRequestActionTypes {
  LoadingAllUsersRequested = 'LoadingAllUsersRequested',
  LoadingUserRequested = 'LoadingUserRequested',
  ChangePasswordRequested = 'ChangePasswordRequested',
  CreateUserRequested = 'CreateUserRequested',
  EditUserRequested = 'EditUserRequested',
  LoadingActiveClientsRequested = 'LoadingAllClientsRequested',
  LoadingArchivedClientsRequested = 'LoadingArchivedClientsRequested',
  LoginRequested = 'LoginRequested',
  NewClientRequested = 'NewClientRequested',
  CreateEventRequested = 'CreateEventRequested',
  EditEventRequested = 'EditEventRequested',
  UploadParticipantsRequested = 'UploadParticipantsRequested',
  UploadParticipantsWithMergeRequested = 'UploadParticipantsWithMergeRequsted',
  UploadParticipantsFromMarchingOrder = 'UploadParticipantsForMarchingOrder',
  UploadParticipantsWithEventSplit = 'UploadParticipantsWithEventSplit',
  UploadParticipantsMarchingOrderData = 'UploadParticipantsMarchingOrderData',
  AddParticipantRequested = 'AddParticipantRequested',
  AddUnknownParticipantRequested = 'AddUnknownParticipantRequested',
  EditParticipantRequested = 'EditParticipantRequested',
  MergeParticipantsRequested = 'MergeParticipantsRequested',
  ConvertToUnknownParticipantRequested = 'ConvertToUnknownParticipantRequested',
  UploadAegisubResultRequested = 'UploadAegisubResultRequested',
  AssignEventRequested = 'AssignEventRequested',
  ActiveEventsRequested = 'ActiveEventsRequested',
  ArchivedEventsRequested = 'ArchivedEventsRequested',
  AllEventParticipantsRequested = 'AllEventParticipantsRequested',
  EventArchivedParticipantsRequested = 'EventArchivedParticipantsRequested',
  EventRequested = 'EventRequested',
  AddEventTransitionRequested = 'AddEventTransitionRequested',
  AllEventVideosRequested = 'AllEventVideosRequested',
  EventArchivedVideosRequested = 'EventArchivedVideosRequested',
  AllUploadedVideosRequested = 'AllUploadedVideosRequested',
  AddEventVideoRequested = 'AddEventVideoRequested',
  AllShopsRequested = 'AllShopsRequested',
  NewShopRequested = 'NewShopRequested',
  EventsStatisticsRequested = 'EventsStatisticsRequested',
  EditClientRequested = 'EditClientRequested',
  DefaultClipConfigurationRequested = 'DefaultClipConfigurationRequested',
  SendParticipantsToGeneratorRequested = 'SendParticipantsToGeneratorRequested',
  SendLiveParticipantsToGeneratorRequested = 'SendLiveParticipantsToGeneratorRequested',
  SendParticipantsToRemotionGeneratorRequested = 'SendParticipantsToRemotionGeneratorRequested',
  SendLiveParticipantsToRemotionGeneratorRequested = 'SendLiveParticipantsToRemotionGeneratorRequested',
  CopyClipConfigurationFromClientRequested = 'copyClipConfigurationFromClient',
  AllEventActionsRequested = 'allEventActionsRequested',
  EventArchivedActionsRequested = 'eventArchivedActionsRequested',
  GenerateParticipantsZipRequested = 'generateParticipantsZipRequested',
  DeleteParticipantsZipRequested = 'deleteParticipantsZipRequested',
  DeleteParticipantsDataRequested = 'deleteParticipantsDataRequested',
  MarkClientUpdateAsReadAction = 'markClientUpdateAsReadAction',
  GetMappedClipTemplateRequested = 'getMappedClipTemplateRequested',
  GenerateParticipantsVgZipRequested = 'generateParticipantsVgZipRequested',
  DeleteParticipantsVgZipRequested = 'deleteParticipantsVgZipRequested',
  DeleteParticipantsVgVideoRequested = 'deleteParticipantsVgVideoRequested',
  GenerateVgVideoCeremonyRequested = 'generateVgVideoCeremonyRequested',
  ClientSummaryClientRequested = 'ClientSummaryClientRequested',
  SendToNLP = 'SendToNLP',
  UnlockClip = 'unlockClip',
  ResetRender = 'resetRender',
}
